module.exports = __webpack_public_path__ + "media/images/logo-en-0d1ab29549d69843df6febba6b169dcd.svg";